import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const badgeVariants = cva(
  'inline-flex items-center gap-1 rounded-md px-1.5 py-0.5 text-[11px] font-medium leading-none',
  {
    variants: {
      tone: {
        muted: 'bg-muted text-muted-foreground',
        primary: 'bg-primary/10 text-primary',
        positive: 'bg-positive/15 text-positive',
        warning: 'bg-warning/15 text-warning',
        negative: 'bg-negative/15 text-negative',
        outline: 'border border-border text-foreground',
      },
    },
    defaultVariants: { tone: 'muted' },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

export function Badge({ className, tone, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ tone, className }))} {...props} />;
}
